import { ListItem } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { Stack } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';

export function BusinessDetailsPageLoading() {
  return (
    <ListItem>
      <Stack space="xxsmall">
        <TextBox variant="heading-4">
          <Skeleton width={200} />
        </TextBox>

        <Skeleton width={400} />

        <Skeleton width={400} />

        <Skeleton width={400} />
      </Stack>
    </ListItem>
  );
}
